
import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuthenticationContext } from "../../Authentication";
import { toast } from "react-toastify";
import { useTokenCallContext } from "../../TokenCall";
const RecentOrdersContext = createContext();


export const RecentOrdersProvider = ({ children }) => {
  const { sessionCustomerId, sessionAccountId } = useAuthenticationContext();
  const validNewCustomer = localStorage.getItem('validNewCustomer') === 'true'
  const validWithOTP = localStorage.getItem('validWithOTP') === 'true'
  const { dataFetchSuccess, currentUrl } = useTokenCallContext()
  const [activeIndex, setActiveIndex] = useState(null);
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const recentCacheName = "recentOrder-inventory-cache";
  const [salesOrders, setSalesOrders] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [error, setError] = useState(null);
  const [products, setProducts] = useState([]);
  const [atuProducts, setAtuProducts] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const cacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/data/fetch-product-data`;
  const cacheName = "test-inventory-cache";
  const atuCacheUrl = `${process.env.REACT_APP_SERVER_URL}/api/atu/get-atu-data`;
  const atuCacheName = "test-atu-cache";
  const [userData, setUserData] = useState(null);
  const [isUserDataFetched, setIsUserDataFetched] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleWidth = () => {
    setIsExpanded(!isExpanded);
  };

  

  const fetchSalesOrders = async () => {
    try {

      setLoading(true);
      const data = JSON.parse(sessionStorage.getItem('userData'));
      const tempAccountGuid = data?.accountId;
      if (!tempAccountGuid) {
        console.log('Account GUID is not present.');
        setLoading(false);
        return;
      }

      // Open recent orders cache
      const cache = await caches.open(recentCacheName);
      const cachedResponse = await cache.match('/api/recent-order/fetch-sales-orders');

      if (cachedResponse) {
        // Use cached data if available
        const cachedData = await cachedResponse.json();
        console.log('Using cached data');
        setSalesOrders(cachedData);
      } else {
        // Fetch from API if no cached data
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/api/recent-order/fetch-sales-orders`,
          {
            accountGuid: tempAccountGuid,
          }
        );

        // Clone and store response in cache
        const responseClone = new Response(JSON.stringify(response.data), {
          headers: { 'Content-Type': 'application/json' },
        });
        await cache.put('/api/recent-order/fetch-sales-orders', responseClone);

        // Update state with fetched data
        setSalesOrders(response.data);
      }

      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
  // Fetch sales orders once user data is fetched
  useEffect(() => {
    if(dataFetchSuccess){
      const currentPath = sessionStorage.getItem('currentPath')
      if(currentPath === '/home/recent-orders'){
        fetchSalesOrders();
      }
    }
  }, [dataFetchSuccess]);

  useEffect(() => {
    // Function to fetch and cache data
    //setLoading(true);
    const fetchAndCacheData = async () => {
      try {
        // Open the cache
        const cache = await caches.open(cacheName);

        // Check if the response is already in the cache
        const cachedResponse = await cache.match(cacheUrl);
        if (cachedResponse) {
          // If cache exists, read and set the products state from cache
          const cachedData = await cachedResponse.json();
          setProducts(cachedData);
          setLoading(false);
        } else {
          // If cache does not exist, fetch from server
          const response = await fetch(cacheUrl);

          if (response.ok) {
            const data = await response.json();

            setProducts(data);

            await cache.put(cacheUrl, response.clone());
            console.log('Data fetched from server and cached:', data);
            setLoading(false);
          } else {
            console.error('Failed to fetch data from server:', response.statusText);

            setLoading(false);
          }
        }
      } catch (error) {
        console.error('Error fetching or caching data:', error);

        setLoading(false);
      }
    };

    if(!validNewCustomer){
      if(validWithOTP){
        if(currentUrl === '/home/recent-orders'){
        fetchAndCacheData();
        }
      }
    }
  }, [cacheUrl, cacheName, currentUrl]);


  useEffect(() => {
    // Function to fetch and cache data
    //setLoading(true);
    const fetchAndCacheData = async () => {
      try {
        // Open the cache
        const cache = await caches.open(atuCacheName);

        // Check if the response is already in the cache
        const cachedResponse = await cache.match(atuCacheUrl);
        if (cachedResponse) {
          // If cache exists, read and set the products state from cache
          const cachedData = await cachedResponse.json();
          setAtuProducts(cachedData);
          setLoading(false);
        } else {
          // If cache does not exist, fetch from server
          const response = await fetch(atuCacheUrl);

          if (response.ok) {
            const data = await response.json();

            setAtuProducts(data);

            await cache.put(atuCacheUrl, response.clone());
            console.log('Data fetched from server and cached:', data);
            setLoading(false);
          } else {
            console.error('Failed to fetch data from server:', response.statusText);

            setLoading(false);
          }
        }
      } catch (error) {
        console.error('Error fetching or caching data:', error);

        setLoading(false);
      }
    };

    if(!validNewCustomer){
      // fetchAndCacheData(); 
    }
  }, [atuCacheUrl, atuCacheName]);

  useEffect(() => {
    //setLoading(true)
    // Ensure products and salesOrders are available and are arrays
    if (!Array.isArray(products) || !Array.isArray(salesOrders) || products.length === 0 || salesOrders.length === 0) {
      return;
    }

    // Iterate through each salesOrder and its details
    const newCombinedData = salesOrders.map((order) => {
      const { details, order: orderInfo } = order;

      // Match product details with sales order details
      const combinedDetails = details.map((detail) => {
        const matchingProduct = products.find(
          (product) => product.productid === detail._productid_value
        );

        if (matchingProduct) {
          // Combine sales order details with matching product details
          return {
            ...detail,
            ...matchingProduct, // Add product details to the detail object
            isMatchingProductFound: true,
          };
        }

        return {
          ...detail,
          isMatchingProductFound: false,
        }; // Return original detail if no matching product found
      });

      return {
        order: orderInfo,
        combinedDetails,
      };
    });

    setOrders(newCombinedData);
    setLoading(false);
  }, [products, salesOrders]);


  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // Function to filter products based on search term
  //  const filterProductsfn = (products, searchTerm) => {
  //   if (!searchTerm) return products; // Return all products if no search term

  //   return products.filter(product =>
  //     (product.name && product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (product.nyc_brand && product.nyc_brand.toLowerCase().includes(searchTerm.toLowerCase())) ||
  //     (product.productnumber && product.productnumber.toLowerCase().includes(searchTerm.toLowerCase()))
  //   );
  // };

  const filterProductsfn = (products, searchTerm) => {
    if (!searchTerm) return products; // Return all products if no search term

    return products.filter(product =>
      (product.name && product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.nyc_brand && product.nyc_brand.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.productnumber && product.productnumber.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  };



  // // Effect to filter combined data whenever the search term changes or orders are updated
  useEffect(() => {
    const newFilteredOrders = orders.map(order => {
      return {
        ...order,
        filteredProducts: filterProductsfn(order.combinedDetails, searchTerm)
      };
    });

    setFilteredOrders(newFilteredOrders);
  }, [orders, searchTerm]);

  // const filteredOrders = orders
  //   .map(order => ({
  //     ...order,
  //     filteredProducts: filterProductsfn(order.products)
  //   }))
  //   .filter(order => order.filteredProducts.length > 0);

  return (
    <RecentOrdersContext.Provider value={{
      orders,
      toggleAccordion,
      handleSearch,
      filteredOrders,
      searchTerm, activeIndex, loading,
      // deleteCacheRecord,
      filterProductsfn,
      products,
      atuProducts,
      isExpanded, setIsExpanded,
      toggleWidth,
      fetchSalesOrders,
      recentCacheName
    }}>
      {children}
    </RecentOrdersContext.Provider>
  );
};

export const useRecentOrdersContext = () => {
  const context = useContext(RecentOrdersContext);
  if (context === undefined) {
    throw new Error('useRecentOrdersContext must be used within a RecentOrdersProvider');
  }
  return context;
};